// Recovered compiled webpack factory 1262. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return d;
      },
    }));
  let r = n(12115),
    o = r.useLayoutEffect,
    l = r.useEffect;
  function d(e) {
    let { headManager: t, reduceComponentsToState: n } = e;
    function d() {
      if (t && t.mountedInstances) {
        let o = r.Children.toArray(Array.from(t.mountedInstances).filter(Boolean));
        t.updateHead(n(o, e));
      }
    }
    return (
      o(() => {
        var n;
        return (
          null == t || null == (n = t.mountedInstances) || n.add(e.children),
          () => {
            var n;
            null == t || null == (n = t.mountedInstances) || n.delete(e.children);
          }
        );
      }),
      o(
        () => (
          t && (t._pendingUpdate = d),
          () => {
            t && (t._pendingUpdate = d);
          }
        ),
      ),
      l(
        () => (
          t && t._pendingUpdate && (t._pendingUpdate(), (t._pendingUpdate = null)),
          () => {
            t && t._pendingUpdate && (t._pendingUpdate(), (t._pendingUpdate = null));
          }
        ),
      ),
      null
    );
  }
}
